module.exports = __webpack_public_path__ + "static/media/hotspot_play.51997991.glb";